import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { DiscountPolicyFormSchemaValues } from 'src/features/discountPolicies/utils/formSchema';
import { DiscountPolicy } from 'src/features/discountPolicies/utils/types';

const RESOURCE = '/discounts/discount-policy/:policyId/';

type MutationFnType = typeof mutationFn;

interface DTO extends DiscountPolicyFormSchemaValues {
    policyId: string;
}
const mutationFn = ({ policyId, ...data }: DTO): Promise<DiscountPolicy> => {
    return axios.put(formatResourcePath(RESOURCE, { policyId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateDiscountPolicy };
